import React, { useState, useRef } from "react";
import "./BodyScanInstructions.css";
import Screen1 from "./Screen1";
import Screen2 from "./Screen2";
import Screen3 from "./Screen3";
import Arrow from "assets/Arrow.icon";
import { ThemeContext } from "contexts";

const BodyScanInstructions: React.FC = () => {
  const theme = React.useContext(ThemeContext);
  const [activeIndex, setActiveIndex] = useState(0);
  const startX = useRef(0);
  const endX = useRef(0);

  const screens = [
    <Screen3 key="screen3" />,
    <Screen1 key="screen1" />,
    <Screen2 key="screen2" />,
  ];

  const handleTouchStart = (e: React.TouchEvent) => {
    startX.current = e.touches[0].clientX;
  };

  const handleTouchEnd = () => {
    const diffX = startX.current - endX.current;
    if (diffX > 50 && activeIndex < screens.length - 1) {
      setActiveIndex(activeIndex + 1);
    } else if (diffX < -50 && activeIndex > 0) {
      setActiveIndex(activeIndex - 1);
    }
  };

  const handleTouchMove = (e: React.TouchEvent) => {
    endX.current = e.touches[0].clientX;
  };

  return (
    <div
      className="container"
      onTouchStart={handleTouchStart}
      onTouchEnd={handleTouchEnd}
      onTouchMove={handleTouchMove}
    >
      <div
        className="arrow"
        style={{
          left: 0,
          display: activeIndex === 0 ? "none" : "flex",
        }}
        onClick={() => setActiveIndex((prev) => prev - 1)}
      >
        <Arrow direction="left" color={theme?.themeColor} />
      </div>
      <div
        className="arrow"
        style={{
          right: 0,
          display: activeIndex === 2 ? "none" : "flex",
        }}
        onClick={() => setActiveIndex((prev) => prev + 1)}
      >
        <Arrow direction="right" color={theme?.themeColor} />
      </div>
      {screens.map((screen, index) => (
        <div
          key={index}
          className={`screen ${index === activeIndex ? "active" : ""}`}
        >
          {screen}
        </div>
      ))}
      <div className="indicators">
        {screens.map((_, index) => (
          <div
            key={index}
            className={`indicator ${index === activeIndex ? "active" : ""}`}
            onClick={() => setActiveIndex(index)}
          />
        ))}
      </div>
    </div>
  );
};

export default BodyScanInstructions;
